import type { AgentGoldenCaseResponse } from '@troia-v3/types';

import { api } from '@/lib/api';

export interface GoldenStatus {
  conversationId: string;
  isGolden: boolean;
}

export const markConversationAsGolden = async (
  conversationId: string,
  agentId?: string,
): Promise<AgentGoldenCaseResponse> => {
  const res = await api.post(
    `agent-golden-cases/conversations/${conversationId}`,
    { agentId },
  );
  return res.data.data;
};

export const unmarkConversationAsGolden = async (
  conversationId: string,
): Promise<void> => {
  await api.delete(`agent-golden-cases/conversations/${conversationId}`);
};

export const getGoldenStatus = async (
  conversationId: string,
): Promise<GoldenStatus> => {
  const res = await api.get(
    `agent-golden-cases/conversations/${conversationId}/status`,
  );
  return res.data.data;
};

export const listAgentGoldenCases = async (
  agentId: string,
): Promise<{ items: AgentGoldenCaseResponse[]; total: number }> => {
  const res = await api.get(`agent-golden-cases/agents/${agentId}`);
  return res.data.data;
};
